import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css'; 
import ImageUpload from '../Image/ImageUpload';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false); 
  const navigate = useNavigate();

  // Function to handle login
  const handleLogin = (e) => {
    e.preventDefault();
   
    if (email === 'kishor002912@gmail.com' && password === '445566') {
      // Save login data to localStorage
      localStorage.setItem('user', JSON.stringify({ email }));
      // Set isLoggedIn state to true
      setIsLoggedIn(true);
    } else {
      setError('Invalid email or password. Please try again.');
    }
  };

  // Function to handle logout
  const handleLogout = () => {
    // Remove user data from localStorage
    localStorage.removeItem('user');
    // Set isLoggedIn state to false
    setIsLoggedIn(false);
    // Redirect to login page
    navigate('/login');
  };

  // Check if user is already logged in
  useEffect(() => {
    const loggedInUser = localStorage.getItem('user');
    if (loggedInUser) {
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <div>
      {!isLoggedIn ? (
        <div className="login-container">
          <h2>Login</h2>
          <form className="login-form" onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email:</label>
              <input className='loginemail' type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Password:</label>
              <input className='loginemail1' type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="login-button">Login</button>
          </form>
        </div>
      ) : (
        <div>
          <ImageUpload />
          <button onClick={handleLogout}>Logout</button>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
